import { createFileRoute } from '@tanstack/react-router'
import { InvoicesSection } from '@ufc/domains/finance'

export const Route = createFileRoute('/finance/invoices')({
  component: InvoicesPage,
})

function InvoicesPage() {
  return <InvoicesSection />
}
